export default function IconRadioChecked() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="#EFF8FF" />
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#1570EF" />
      <circle cx="10" cy="10" r="4" fill="#1570EF" />
    </svg>
  );
}
